import React from 'react';

const RipIcon = () => (
    <svg className="map-icon map-icon-rip" viewBox="0 0 48 48">
        <path
            className="map-icon-stroke-outter"
            d="M24.1,6A12.89,12.89,0,0,0,11.22,18.89V33.38a2.44,2.44,0,0,0-1.7,1.34l-.06.12-1,3.07a2.43,2.43,0,0,0,2.27,3.29H37.43a2.43,2.43,0,0,0,2.27-3.29l-1-3.07-.06-.12A2.44,2.44,0,0,0,37,33.38V18.89A12.89,12.89,0,0,0,24.1,6Z"
        />
        <path
            className="map-icon-rip-fill"
            d="M10.39,38.59l1-3a.43.43,0,0,1,.39-.25h1.5V18.89a10.88,10.88,0,0,1,21.76,0V35.32h1.5a.43.43,0,0,1,.39.25l1,3a.43.43,0,0,1-.39.61H10.77a.43.43,0,0,1-.39-.61"
        />
        <path
            className="map-icon-stroke-inner"
            d="M37.82,38.59l-1-3a.43.43,0,0,0-.39-.25H35V18.89a10.88,10.88,0,0,0-21.76,0V35.32h-1.5a.43.43,0,0,0-.39.25l-1,3a.43.43,0,0,0,.39.61H37.43A.43.43,0,0,0,37.82,38.59Zm-23.6-3.27V18.89a9.88,9.88,0,0,1,19.76,0V35.32H32.69l0-16a8.85,8.85,0,0,0-8.59-9.07,8.85,8.85,0,0,0-8.59,9.07l0,16H14.22Zm17.72,0H16.2l0-16A8.1,8.1,0,0,1,24.07,11a8.1,8.1,0,0,1,7.84,8.32ZM11.56,38.2l.59-1.88H36.06l.59,1.88Z"
        />
        <path
            className="details"
            d="M20.61,20.31H20v2.14H18.84V16.6h1.89a1.9,1.9,0,0,1,1.37.46,1.71,1.71,0,0,1,.49,1.31A1.7,1.7,0,0,1,21.74,20l1,2.4v.06H21.49Zm-.59-1h.67a.62.62,0,0,0,.53-.23,1,1,0,0,0,.18-.63q0-.88-.69-.88H20Zm5,3.13H23.82V16.6H25Zm2.55-2.06v2.06H26.37V16.6h2a1.82,1.82,0,0,1,1.38.54,1.93,1.93,0,0,1,.52,1.4,1.81,1.81,0,0,1-.51,1.36,1.94,1.94,0,0,1-1.42.5Zm0-1h.81a.64.64,0,0,0,.52-.22,1,1,0,0,0,.18-.64,1.15,1.15,0,0,0-.19-.7.6.6,0,0,0-.51-.27h-.82Z"
        />
        <circle className="details" cx="21.89" cy="26.51" r="0.51" />
        <circle className="details" cx="25.98" cy="26.51" r="0.51" />
        <circle className="details" cx="21.89" cy="30.6" r="0.51" />
        <circle className="details" cx="25.98" cy="30.6" r="0.51" />
    </svg>
);

export default React.memo(RipIcon);
